<template>
    <div>

    <div class="p_title container bottomline mt30">
        <div class="titlebox mt20">
            <h5>{{mainmenuitem.title}}</h5>
            <p>{{mainmenuitem.description}}</p>
        </div>
        <ul class="titlemenu mt50">
            <li v-for="(menu,index) in childmenus" :key="index" :class="pid == menu.id ? 'active' : '' ">
                <a href="javascript:void(0)" @click="gotolist(menu)">{{menu.title}}</a>
            </li>
        </ul>
        <BizMenu :menuarray="childmenus" @gotolist="gotolist" :pid="pid"></BizMenu>
    </div>
    <div class="p_body container mt50">
        <div class="p_body_content newsleft">
            <div class="p_body_content_title fontbold">
                <h5>{{itemData.title}}</h5>
                <p>发布日期：{{formatdata(itemData.createdTime)}}</p> <div class="font-size-box">字号：<a id="font-dec">A-</a>  <a id="font-add">A+</a> </div>
            </div>
            <div class="p_body_content_news mt20" v-html="itemData.content"></div>
        </div>
        <div class="p_body_content_rightlink">
            <p class="party_concern_title">相关内容</p>
            <ul class="mt30">
            <li v-for="(value) in tableData" :key="value.id">
                <a href="javascript:void(0)" @click="gotodetail(value.id)">
                    <p class="newstitle">{{value.title}}</p>
                    <span>发布日期：{{formatdata(value.createdTime)}}</span>
                </a>
            </li>
        </ul>
        </div>
        
    </div>

    </div>
</template>

<script>
import util from '@/tools/js/util';
import configration from '../tools/js/enumconfig'
import BizMenu from '../components/bizmenu.vue'

export default {
    data(){
        return {
            totleCount:0,
            itemData:{},
            tableData:[],
            parameters:{
                parentId:'',
                type:0
            },
            id:'',
            showtitle:'党群纪检',
            imgbaseurl : this.$baseURL.fileurl,
            
            mainmenuitem:{},            //主显示分类
            childmenutree:[],   //  treemenu
            childmenus:[],
            fid:'',
            pid:'',
        }
    },
     methods:{
        getData:function(id){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getitem?id='+id)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemData = response.data.data;
                    vm.showtitle = vm.itemData.title;
                }
            });
        },
        initmenu(){
            let vm = this;
            if(vm.childmenutree == undefined || vm.childmenutree.length == 0) 
            { 
                vm.childmenutree = JSON.parse(localStorage.getItem(configration.config.enum.cache_menu))
            }

            vm.childmenus = [];
            if(vm.fid.length>0){
                //获取子菜单
                for(let i=0;i< vm.childmenutree.length;i++ ){
                    if(vm.childmenutree[i].id == vm.fid)
                    {
                        vm.mainmenuitem = vm.childmenutree[i];
                        vm.childmenus = vm.childmenutree[i].childs;
                        break;
                    }
                }
            }

        },
        formatdata:function(e){
            return util.formatDate.format(e,'yyyy-MM-dd')
            //return e.substr(0,10);
        },
        getList:function(){
            let vm = this;
            vm.$httpi.post('/api/v1/articles/doc/gettoplist', vm.parameters)
            .then(function (response) {
                if(response.data.success){
                    vm.tableData = response.data.data;
                }
            });
            
        },
        gotodetail(id){
            const vm = this;
            vm.$router.push({path:'/party/detail',query:{id:id,pid:vm.parameters.parentId,fid:vm.fid}});
            vm.initpage();
        },
        gotolist(item){
            const vm = this;
            vm.$router.push({path:'/party/list',query:{pid:item.id,fid:item.parentId}});
        },
        initpage(){
            let vm = this;
            //绑定
            if(vm.$route.query.fid!=undefined && vm.$route.query.fid.length>0)
            {
                vm.fid = vm.$route.query.fid;
            }
            if(vm.$route.query.id!=undefined && vm.$route.query.id.length>0)
            {
                vm.id = vm.$route.query.id;
                vm.getData(vm.$route.query.id);
            }
            if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
            {
                vm.parameters.parentId = vm.$route.query.pid;
                vm.pid = vm.$route.query.pid;
                vm.getList();
            }
            vm.initmenu();
        }
     },
     mounted() {
        let vm = this;
        //绑定
        vm.initpage();

        $("#font-dec").click(function(){
            let tp =  $(".p_body_content_news")
            console.log('awdawd');
            let currentSize = parseInt(tp.css("font-size"));
            currentSize-=3;
            tp.css({"font-size": currentSize + "px"});

        });

        $("#font-add").click(function(){
            let tp =  $(".p_body_content_news")
            let currentSize = parseInt(tp.css("font-size"));
            currentSize+=3;
            tp.css({"font-size": currentSize + "px"});
        });
    },
    components:{
       BizMenu
    },
}
</script>


<style>



</style>